module.exports = __webpack_public_path__ + "img/jd@2x.5c44424d.png";